import { useQuery } from '@tanstack/react-query';
import {
  clientGetFirmClientIntakeQuestions,
  clientGetFirmClientIntakeResponses,
  clientGetFirmIntakeQuestions,
  useGraphqlClient,
} from '../graphql';
import { firmIntakeQuestionKeys } from './queryKeys';

export const useFirmIntakeQuestions = (firmID: string | undefined | null) => {
  const gqlClient = useGraphqlClient();

  const firmIntakeQuestionsQuery = useQuery({
    enabled: !!firmID,
    queryKey: firmIntakeQuestionKeys.forFirm(firmID),
    queryFn: () => {
      if (firmID) return clientGetFirmIntakeQuestions(gqlClient, { firmID });
    },
  });

  return { firmIntakeQuestions: firmIntakeQuestionsQuery.data ?? [], firmIntakeQuestionsQuery };
};

export const useFirmClientIntakeQuestions = (firmClientID: string | undefined | null) => {
  const gqlClient = useGraphqlClient();

  const firmClientIntakeQuestionsQuery = useQuery({
    enabled: !!firmClientID,
    queryKey: firmIntakeQuestionKeys.forFirmClient(firmClientID),
    queryFn: () => {
      if (firmClientID) return clientGetFirmClientIntakeQuestions(gqlClient, { firmClientID });
    },
  });

  return {
    firmClientIntakeQuestions: firmClientIntakeQuestionsQuery.data ?? [],
    firmClientIntakeQuestionsQuery,
  };
};

export const useFirmClientIntakeResponses = (firmClientID: string | undefined | null) => {
  const gqlClient = useGraphqlClient();

  const firmClientIntakeResponsesQuery = useQuery({
    enabled: !!firmClientID,
    queryKey: firmIntakeQuestionKeys.responsesForFirmClient(firmClientID),
    queryFn: () => {
      if (firmClientID) return clientGetFirmClientIntakeResponses(gqlClient, { firmClientID });
    },
  });

  return {
    firmClientIntakeResponses: firmClientIntakeResponsesQuery.data ?? [],
    firmClientIntakeResponsesQuery,
  };
};
